import { cn } from "@/lib/utils";
import { gradeShort } from "@/lib/format";

// Grado prodotto: testo semplice in monospace (mai badge con sfondo colorato).
export function GradeBadge({ grade, compact = false, className = "", ...rest }) {
  const label = gradeShort(grade).toUpperCase();
  return (
    <span
      className={cn(
        "inline-flex items-center font-mono uppercase leading-none tracking-mono text-muted-foreground",
        compact ? "text-[9px]" : "text-[10px]",
        className
      )}
      data-testid="product-card-grade-badge"
      {...rest}
    >
      {label}
    </span>
  );
}
